module.exports = __webpack_public_path__ + "static/media/Vision_Vector_resized.cc323f73.png";